import { render, staticRenderFns } from "./settingBlack.vue?vue&type=template&id=c99fa54e&"
import script from "./settingBlack.vue?vue&type=script&lang=ts&"
export * from "./settingBlack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports